import { render, staticRenderFns } from "./BackgroundParticle.vue?vue&type=template&id=f85fd6b8&scoped=true&"
import script from "./BackgroundParticle.vue?vue&type=script&lang=js&"
export * from "./BackgroundParticle.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundParticle.vue?vue&type=style&index=0&id=f85fd6b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85fd6b8",
  null
  
)

export default component.exports